import { useEffect } from 'react';

import { FileStatus } from 'services/file.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { getDefaultFile } from 'components/app/_helpers/_app.helper';
import { passFileAccessedAt, selectFiles, selectSelectedFile } from 'components/app/_mediator/app-files.slice';
import { setSelectedFile } from 'components/app/projects/_mediator/projects.slice';

export const useSelectorFiles = () => {
  const fileStatuses = useAppSelector((state) => state.app__files.statuses);
  const selectedFile = useAppSelector(selectSelectedFile);
  const { videos } = useAppSelector(selectFiles);
  const dispatch = useAppDispatch();

  // select default file
  useEffect(() => {
    if (!videos.length) return;
    if (selectedFile) dispatch(passFileAccessedAt(selectedFile.id));
    else {
      const readyFiles = videos.filter((el) =>
        [FileStatus.Available, FileStatus.PendingProcessing].includes(fileStatuses[el.id])
      );
      const selectedFileId = readyFiles.length ? getDefaultFile(readyFiles)! : getDefaultFile(videos)!;
      dispatch(passFileAccessedAt(selectedFileId));
      dispatch(setSelectedFile(selectedFileId));
    }
  }, []);
};
